import { Injectable } from '@angular/core';

@Injectable()
export class ProductIconService {
  constructor() {}

  public getIconTypeFromPlc(plc: string): string {
    switch (plc) {
      case 'FI':
      case 'MV':
        return 'Network';
      case 'CLD':
        return 'ICT';
      case 'MMAL':
        return 'Newsletter';
      case 'TVE':
        return 'Television';
      case 'EP':
        return 'Articles';
    }
  }
}
